module.exports = __webpack_public_path__ + "static/media/MainIcon.ccc83cd6.svg";